import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Loading from 'components/dumb/loading/Loading'
import AdxInput from 'components/custom/AdxInput'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import rocket_2 from 'pages/onboarding-reset-password/assets/rocket_2.png'
import { myAccount } from 'services/api/authentication'
import { useQuery } from 'react-query'
import { presignURL } from 'services/api/presign-url'
import axios from 'axios'
import { storeProfilePhoto } from 'services/api/presign-url'
import { authContext } from 'contexts/AuthContext'
import AdxDropzoneCompanyImage from 'components/reusable/AdxDropzoneCompanyImage'
import Bugsnag from '@bugsnag/js'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const OnboardingPersonalDetails = () => {
  const [loading, setLoading] = useState(false)
  const [photo, setPhoto] = useState(null)

  const { auth, setAuthData } = useContext(authContext)

  const navigate = useNavigate()

  const { data: myAccountData } = useQuery('myAccount', async () => {
    const { data } = await myAccount()
    return data
  })

  const [errorModal, setErrorModal] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const uploadPhoto = async () => {
    if (photo !== null) {
      return new Promise(async (resolve, reject) => {
        if (auth.data.tenant_id === undefined) {
          reject(new Error('Internal error. Tenant id is undefined.'))
        } else {
          try {
            setLoading(true)
            const results = await presignURL({
              bucket: process.env.REACT_APP_AWS_BUCKET,
              key: `tenant_${auth.data.tenant_id}/profile_photo/` + photo?.name,
            })
            const awsRequest = axios.create()
            delete awsRequest.defaults.headers.common['Authorization']
            await awsRequest.put(results.data.url, photo, {
              headers: {
                'Content-Type': photo?.type,
              },
            })
            await storeProfilePhoto({ profile_image: photo?.name })
          } catch (e) {
            setErrorMsg(e.message)
            setErrorModal(true)
            Bugsnag.notify(e)
          } finally {
            resolve(setLoading(false))
          }
        }
      })
    }
  }

  const handleNextButton = async () => {
    try {
      await uploadPhoto()
      await setAuthData()
      navigate('/onboarding-job-information')
    } catch (e) {
      setErrorMsg(e.message)
      setErrorModal(true)
      Bugsnag.notify(e)
    }
  }

  return (
    <OnboardingContainer
      srcRightPhoto={rocket_2}
      bgColorRight="alternate.main"
      topRightPhoto={'115%'}
      leftRightPhoto={'115%'}
      heightRightPhoto={'125%'}
      transformRightPhoto={`translate(${-100}%, ${-100}%)`}
    >
      <Loading show={loading} />
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
      >
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height="650px"
          mr={{ lg: 7.6875 }}
          p={{ xs: 2 }}
          position={'relative'}
        >
          <Box mb={4}>
            <Typography variant="body2" mb={1} color="alternate.main">
              Step 1
            </Typography>
            <Typography variant="body1" textAlign="justify">
              Personal Details
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
            <AdxDropzoneCompanyImage
              photoUpload={photo}
              setPhotoUpload={setPhoto}
              file={auth?.data?.profile_image_url}
              radiusLength={90}
            />
            <Typography variant="body1" width="100%" textAlign="center">
              Profile Picture
            </Typography>
          </Box>

          <AdxInput
            label="Employee name"
            sxLabel={{
              color: 'black.main',
            }}
            sx={{
              marginBottom: '16px',
            }}
            size="standard"
            placeholder="Employee name"
            value={myAccountData && myAccountData.staff.name}
            disabled
          />
          <Box
            width={'100%'}
            display="flex"
            gap={2}
            justifyContent="space-between"
            position={{ lg: 'absolute' }}
            bottom={{ lg: 0 }}
            pr={{ lg: 4 }}
          >
            <AdxButton
              variant={'contained'}
              key={1}
              sx={{ width: '100%' }}
              size={'standard'}
              onClick={() => handleNextButton()}
            >
              Next
            </AdxButton>
          </Box>
        </Box>
      </Box>

      <AdxInfoModal
        open={errorModal}
        handleClose={() => setErrorModal(false)}
        muiIcon="error"
        iconColor="error.main"
        title="Error"
        subtitle={errorMsg}
        footerButtons
        firstBtnLabel={'Ok'}
        firstBtnHandle={() => setErrorModal(false)}
      ></AdxInfoModal>
    </OnboardingContainer>
  )
}

export default OnboardingPersonalDetails
